const NOT_NEED_CHECK_CATEGORIES = [
  'mobileRehabilitation',
  'homeDentalCare',
  'homeNursingCare',
  'homeMedicalCare'
]

export const checkFilesRequired = ({ category, files }) => {
  if (category === 'mobileDietitian') {
    const { carePlan } = files
    return carePlan
  }

  if (category === 'mobilePharmacist') {
    const { carePlan } = files
    return carePlan
  }

  if (category === 'mobilePsychologist') {
    const { carePlanWithTransit } = files
    return carePlanWithTransit
  }

  if (category === 'homeServices') {
    const { taiwaneseIdFront, taiwaneseIdBack } = files
    return taiwaneseIdFront && taiwaneseIdBack
  }

  if (NOT_NEED_CHECK_CATEGORIES.includes(category)) {
    return true
  }
  return false
}